import * as actionTypes from '../actionTypes';

const state = {
  isLoadingGetHealthFormTemplates: false,
  getHealthFormTemplatesMessage: '',
  getHealthFormTemplatesFailed: '',

  isLoadingGetHealthFormSetting: false,
  getHealthFormSettingMessage: '',
  getHealthFormSettingFailed: '',

  isLoadingPatchHealthFormSetting: false,
  patchHealthFormSettingMessage: '',
  patchHealthFormSettingFailed: '',
};

const initializeStates = JSON.parse(JSON.stringify(state));

function healthFormReducer(globalState = state, action) {
  switch (action.type) {
    case actionTypes.INITIALIZE_STATES_FULFILLED:
      return {
        ...initializeStates,
      };
    case actionTypes.GET_HEALTH_FORM_TEMPLATES_PENDING:
      return {
        ...globalState,
        isLoadingGetHealthFormTemplates: true,
      };
    case actionTypes.GET_HEALTH_FORM_TEMPLATES_FULFILLED:
      return {
        ...globalState,
        isLoadingGetHealthFormTemplates: false,
        getHealthFormTemplatesMessage: action.data,
        getHealthFormTemplatesFailed: '',
      };
    case actionTypes.GET_HEALTH_FORM_TEMPLATES_FAILURE:
      return {
        ...globalState,
        isLoadingGetHealthFormTemplates: false,
        getHealthFormTemplatesFulfilled: '',
        getHealthFormTemplatesFailed: action.error,
      };
    case actionTypes.GET_HEALTH_FORM_SETTING_PENDING:
      return {
        ...globalState,
        isLoadingGetHealthFormSetting: true,
      };
    case actionTypes.GET_HEALTH_FORM_SETTING_FULFILLED:
      return {
        ...globalState,
        isLoadingGetHealthFormSetting: false,
        getHealthFormSettingMessage: action.data,
        getHealthFormSettingFailed: '',
      };
    case actionTypes.GET_HEALTH_FORM_SETTING_FAILURE:
      return {
        ...globalState,
        isLoadingGetHealthFormSetting: false,
        getHealthFormTemplatesMessage: '',
        getHealthFormSettingFailed: action.error,
      };
    case actionTypes.PATCH_HEALTH_FORM_SETTING_PENDING:
      return {
        ...globalState,
        isLoadingPatchHealthFormSetting: true,
      };
    case actionTypes.PATCH_HEALTH_FORM_SETTING_FULFILLED:
      return {
        ...globalState,
        isLoadingPatchHealthFormSetting: false,
        patchHealthFormSettingMessage: action.data,
        patchHealthFormSettingFailed: '',
      };
    case actionTypes.PATCH_HEALTH_FORM_SETTING_FAILURE:
      return {
        ...globalState,
        isLoadingPatchHealthFormSetting: false,
        patchHealthFormSettingMessage: '',
        patchHealthFormSettingFailed: action.error,
      };
    default:
      return globalState;
  }
}

export { healthFormReducer as default };
